import FacebookIcon from '../../assets/social-media-icons/facebook.png';
import InstagramIcon from '../../assets/social-media-icons/instagram.png';
import LinkedInIcon from '../../assets/social-media-icons/linkedin.png';
import XIcon from '../../assets/social-media-icons/x.png';
import ThreadsIcon from '../../assets/social-media-icons/threads.png';
import BlueskyIcon from '../../assets/social-media-icons/bluesky.png';
import SMSIcon from '../../assets/social-media-icons/sms.png';
import DiscordIcon from '../../assets/social-media-icons/discord.png';
import SignalIcon from '../../assets/social-media-icons/signal.png';
import TelegramIcon from '../../assets/social-media-icons/telegram.png';

export const SOCIAL_PLATFORMS = [
  { value: 'facebook', name: 'Facebook', icon: FacebookIcon },
  { value: 'instagram', name: 'Instagram', icon: InstagramIcon },
  { value: 'linkedin', name: 'LinkedIn', icon: LinkedInIcon },
  { value: 'twitter', name: 'X (formerly Twitter)', icon: XIcon },
  { value: 'threads', name: 'Threads', icon: ThreadsIcon },
  { value: 'bluesky', name: 'Bluesky', icon: BlueskyIcon },
  { value: 'sms', name: 'SMS', icon: SMSIcon },
  { value: 'discord', name: 'Discord', icon: DiscordIcon },
  { value: 'signal', name: 'Signal', icon: SignalIcon },
  { value: 'telegram', name: 'Telegram', icon: TelegramIcon },
];

export const PLATFORM_STYLES = {
  instagram: {
    name: 'Instagram',
    icon: '📸',
    headerClasses: ['bg-gradient-to-r', 'from-purple-500', 'to-pink-500', 'text-white'],
    contentClasses: ['font-sans'],
    textClasses: ['text-base', 'leading-relaxed'],
    hashtagClasses: ['text-blue-500', 'font-medium'],
    metricClasses: ['text-sm', 'text-gray-600', 'dark:text-gray-400'],
    metrics: ['❤️ 0 likes', '💬 0 comments', '🔄 Share'],
  },
  // ... other platform styles
};
